<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete
                        label="Department"
                        variant="outlined" 
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="department_id.value.value"
                        :items="getHrmDepartmentList"
                        :item-title="(item) => item ? `${item.name ? item.name : ''} - ${item.code}` : ''"
                        item-value="id"
                        @update:modelValue="onDepartmentChange"
                        :error-messages="department_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete
                        label="Employee"
                        variant="outlined" 
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="employee_id.value.value"
                        :items="getHrmEmployeeList"
                        :item-title="(item) => item ? `${item.name ? item.name : ''} - ${item.code}` : ''"
                        item-value="id"
                        :error-messages="employee_id.errorMessage.value"
                        autocomplete="off"
                        clearable>
                      </v-autocomplete>
                    </v-col>


                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete 
                      label="Order Category"
                      variant="outlined" 
                      density="compact"
                      bg-color="grey-lighten-4" 
                      v-model="order_category.value.value"
                      :items="[{ name: 'general', display_text: 'General' }, { name: 'production', display_text: 'Production' }]"
                      :item-title="(item) => `${item.display_text}`" 
                      item-value="name"
                      :error-messages="order_category.errorMessage.value" 
                      autocomplete="off"
                      clearable
                      >
                    </v-autocomplete>

                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Employee Sales Reports</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    
                  </v-col>
                </v-row>

                <!-- <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :loading="loading"
                  :items-per-page="-1"
                  :search="search"
                  :hover="true"
                  class="elevation-1"
                  density="comfortable"
                  hide-default-footer
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template #tfoot>
                    <tr class="font-weight-bold">
                      <td colspan="8" class="text-center">Grand Totals:</td>
                      <td class="text-left">{{ reportData.reduce((prev, cur) => { return +prev + +cur.total}, 0) }}</td>
                      <td class="text-left">{{ reportData.reduce((prev, cur) => { return +prev + +cur.paid}, 0) }}</td>
                      <td class="text-left">{{ reportData.reduce((prev, cur) => { return +prev + +cur.total_paid}, 0) }}</td>
                      <td class="text-left">{{ reportData.reduce((prev, cur) => { return +prev + +cur.due_amount}, 0) }}</td>
                      <td colspan="3"></td>
                    </tr>
                  </template>
                </v-data-table> -->

                <div v-for="(emp, eIndex) in reportData" :key="eIndex" class="mb-6">
                  <v-card flat color="blue-grey-lighten-5" class="pa-3 mb-2">
                    <div class="d-flex justify-space-between">
                      <div class="font-weight-bold">
                        {{ emp.employee_name }} - <span class="text-green-darken-4">{{ emp.employee_code }}</span>
                      </div>
                      <div class="text-end">
                        <strong class="text-green-darken-4">Total Sales:</strong>
                        {{ formatCurrency(emp.employee_total_sales) }}
                        &nbsp;<span class="text-red-accent-3">|</span>&nbsp;
                        <strong class="text-green-darken-4">Paid:</strong>
                        {{ formatCurrency(emp.employee_total_paid) }}
                        &nbsp;<span class="text-red-accent-3">|</span>&nbsp;
                        <strong class="text-green-darken-4">Due:</strong>
                        {{ formatCurrency(emp.employee_total_due) }}
                      </div>
                    </div>
                  </v-card>

                  <v-data-table
                    :headers="headers"
                    :items="emp.details"
                    :items-per-page="-1"
                    :search="search"
                    class="elevation-1"
                    hide-default-footer
                    density="compact"
                  >
                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <template #item.total_sales="{ item }">
                      {{ formatCurrency(item.total_sales) }}
                    </template>

                    <template #item.total_paid="{ item }">
                      {{ formatCurrency(item.total_paid) }}
                    </template>

                    <template #item.total_due="{ item }">
                      {{ formatCurrency(item.total_due) }}
                    </template>
                  </v-data-table>
                </div>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { ref } from "vue";
import { useStore } from "vuex";
import * as yup from "yup";
import Axios from "axios";
import { getEmployeeSalesDetailsReport  } from '@/store/api.js'
import { prevDay } from "vuetify/lib/labs/VCalendar/util/timestamp";

export default {
  components: {
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false, },
      { title: "SO Invoice", align: "center", key: "sale_order_code", sortable: false, },
      { title: "SI Invoice", align: "center", key: "invoice_code", sortable: false, },
      { title: 'Customer Name', key: 'company_name', align: 'left', sortable: false },
      { title: "SI Date", align: "center", key: "sale_invoice_date", sortable: false, },
      { title: 'Company Owner Name', key: 'company_owner_name', align: 'left', sortable: false },
      { title: 'Order Type', key: 'order_category', align: 'center', sortable: false },
      { title: 'Total Sales', key: 'total_sales', align: 'right', sortable: false },
      { title: 'Advance', key: 'total_advance', align: 'right', sortable: false },
      { title: 'Total Paid', key: 'total_paid', align: 'right', sortable: false },
      { title: 'Total Due', key: 'total_due', align: 'right', sortable: false },
    ],
  }),
  watch: {},
  created() {
    if(this.$store.getters.getHrmDepartmentList.length == 0){
      this.$store.dispatch('getHrmDepartmentList');
    };
    if (this.$store.getters.getHrmEmployeeList.length == 0) {
      this.$store.dispatch("getHrmEmployeeList");
    }
  },
  computed: {
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label("From Date"),
        to_date: yup.date().nullable().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const department_id = useField("department_id");
    const employee_id = useField("employee_id");
    const invoice_code = useField('invoice_code');
    const order_category = useField('order_category');
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const reportData = ref([]);
    const filters = ref({});

    const submit = handleSubmit(async (values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);

      filters.value = {
        department_id: department_id.value?.value,
        employee_id: employee_id.value?.value,
        order_category: order_category.value?.value,
        from_date: values.from_date,
        to_date: values.to_date,
      };

      try {
        const { data } = await Axios.post(getEmployeeSalesDetailsReport, filters.value)
        reportData.value = data.data
        // console.log(reportData.value);
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    });

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 })

    return {
      submit,
      from_date,
      to_date,
      department_id,
      employee_id,
      order_category,
      invoice_code,
      reportData,
      filters,
      formatCurrency,
      errorMessages,
      loading,
    };
  },
  methods: {
    async onDepartmentChange(selectedId) {
      if (!selectedId) {
        this.department_id.value.value = null;
        return;
      }

      try {
        const data = await this.$store.dispatch("getHrmEmployeeList", { params: { department_id: selectedId } });
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$router.push({
        name: "add-crm-proposal",
        query: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Sale Statement", "sale_statement_reports_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });
      this.$exportTableToExcel(data, "sale_statement_reports_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "sale_statement_reports_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
<style scoped>
.panel-header {
  font-weight: bold;
  font-size: 16px;
}
</style>
